var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.165c4.748 0 8.658-3.91 8.658-8.658 0-4.74-3.918-8.658-8.666-8.658-4.74 0-8.65 3.918-8.65 8.658 0 4.748 3.91 8.658 8.658 8.658Zm-2.681-5.122a.844.844 0 0 1-.847-.863c0-.216.091-.432.25-.59l2.066-2.067-2.067-2.075a.844.844 0 0 1 .598-1.444c.257 0 .448.083.614.249L9.5 8.312l2.084-2.067a.808.808 0 0 1 .614-.25.84.84 0 0 1 .846.847.815.815 0 0 1-.249.606L10.72 9.523l2.067 2.059a.815.815 0 0 1 .25.598c0 .49-.374.863-.856.863a.831.831 0 0 1-.622-.25L9.5 10.736l-2.05 2.059a.85.85 0 0 1-.631.249Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXButton);
export default __webpack_public_path__ + "static/media/xButton.d523e3266f7ae62cdaaabeb6e98cdab6.svg";
export { ForwardRef as ReactComponent };